<div class="panel" [hidden]="hidden()" data-testid="wcg-create-entity-panel-investigator">
    <p class="panel__placeholder">Investigator creation not yet available.</p>
</div>
